import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Skeleton, Button, Modal,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCamera, faSignOutAlt, faArrowLeft, faSignOutAlt as faExit,
} from '@fortawesome/free-solid-svg-icons';
import { setTitleAction } from '../../../state/actions/creators/app.actioncreator';
import {
  getNoConformidadAction,
  seleccionarNoConformidadAction,
  deseleccionarNoConformidadAction,
} from '../../../state/actions/creators/noconformidades/noconformidades.actioncreator';
import { Box, FloatingButton } from '../../shared/components';
import InlineCard from '../components/InlineCard';
import TitleContentBox from '../components/TitleContentBox';
import { enableNavigationAction } from '../../../state/actions/creators/navigation.actioncreator';
import HeaderPageLayout from '../../app/layout/headerPage.layout';
import {
  logoutAction,
} from '../../../state/actions/creators/auth.actioncreator';

class FichaNoConformidad extends Component {
  constructor() {
    super();
    this.state = {
      modalLogout: null,
    };
  }

  componentWillMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const { noConformidades, getNoConformidadAction, match: { params: { id } } } = this.props;
    const { seleccionada } = noConformidades;

    if (seleccionada !== null && id !== null) {
      getNoConformidadAction(id);
    }
  }

  onClickEditar(noConformidadSeleccionada) {
    const { history } = this.props;
    history.push(`/noconformidades/editar/${noConformidadSeleccionada.id}`);
  }


  getActionButtons() {
    return (
      <Box>
        <Button type="link" shape="circle" onClick={() => this.confirm()}>
          {' '}
          <FontAwesomeIcon icon={faSignOutAlt} />
        </Button>
      </Box>
    );
  }

  getNavigationButtons() {
    return (
      <Box>
        <Button type="link" shape="circle" onClick={() => this.volverAtras()}>
          {' '}
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
      </Box>
    );
  }

  msgBorrarImg(source) {
    console.log(arguments);
    // if (source) {
    //   window.open(this.source);
    // }
  }

  volverAtras() {
    const { history } = this.props;
    deseleccionarNoConformidadAction();
    history.push('/#/noconformidades/listar');

    // history.goBack();
  }

  confirm() {
    this.setState({
      modalLogout: (Modal.confirm({
        title: '¿Seguro que quieres salir de Qualitas?',
        content: '',
        okText: 'Salir',
        cancelText: 'Cancelar',
        icon: null,
        onOk: e => this.okLogout(e),
      })),
    });
  }

  okLogout(e) {
    const { logoutAction } = this.props;
    const { modalLogout } = this.state;
    if (modalLogout) modalLogout.destroy();
    logoutAction();
  }

  render() {
    const { noConformidades, history, match: { params: { id } } } = this.props;

    const {
      seleccionada,
    } = noConformidades;
    const {
      nombre, observaciones, fecha_creacion: fechaCreacion,
      tipo_no_conformidad_str: tipoNoConformidadStr, creado_por_str: creadoPorStr,
      clientes_string: clientesString, proveedores_string: proveedoresString,
      usuarios_implicados_string: usuariosImplicadosString, tipologias_string: tipologiasString,
      procedimientos_string: procedimientosString, loading, sede_str: sedeStr,
      subcontrata_str: subcontrataStr,
    } = seleccionada || {};
    let observacionesConEvento = '';

    if (observaciones) {
      observacionesConEvento = observaciones.replace('<img ', '<img onclick="console.log(this);window.open(this.src);" ');
    }
    return (
      <HeaderPageLayout
        title="Ficha de No Conformidad"
        p={2}
        actionButtons={this.getActionButtons()}
        navigationButton={this.getNavigationButtons()}
      >

        <Box id="fichaNoConformidadPage">
          <InlineCard headerText="NOMBRE" content={nombre} />
          <InlineCard
            headerText="DESCRIPCIÓN"
            content={(
              <Skeleton title={false} loading={loading}>
                <div dangerouslySetInnerHTML={{ __html: observaciones }} />

              </Skeleton>
            )}
          />
          <InlineCard
            headerText="DATOS GENERALES"
            content={(
              <Box>
                <TitleContentBox mb={2} title="FECHA DE APERTURA" content={fechaCreacion} loading={loading} />
                <TitleContentBox mb={2} title="TIPO NO CONFORMIDAD" content={tipoNoConformidadStr} loading={loading} />
                <TitleContentBox mb={2} title="CREADO POR" content={creadoPorStr} loading={loading} />
                <TitleContentBox mb={2} title="SEDE" content={sedeStr} loading={loading} />
                <TitleContentBox mb={2} title="SUBCONTRATA" content={subcontrataStr} loading={loading} />
              </Box>
          )}
          />
          <InlineCard
            headerText="DATOS CLIENTE"
            content={(
              <Box>
                <TitleContentBox mb={2} title="CLIENTES" content={clientesString} loading={loading} />
                <TitleContentBox mb={2} title="PROVEEDORES" content={proveedoresString} loading={loading} />
                <TitleContentBox mb={2} title="RR.HH. CAUSANTE" content={usuariosImplicadosString} loading={loading} />
              </Box>
          )}
          />
          <InlineCard
            headerText="PROCEDIMIENTO"
            content={(
              <Box>
                <TitleContentBox mb={2} title="TIPOLOGÍA" content={tipologiasString} loading={loading} />
                <TitleContentBox mb={2} title="PROCEDIMIENTO" content={procedimientosString} loading={loading} />
              </Box>
          )}
          />
          <FloatingButton icon={faCamera} onClick={() => history.push(`/noconformidades/mostrar/${id}/camara`)} />
        </Box>
      </HeaderPageLayout>
    );
  }
}

function mapStateToProps({ noConformidades }) {
  return {
    noConformidades,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getNoConformidadAction,
    setTitleAction,
    enableNavigationAction,
    logoutAction,
    seleccionarNoConformidadAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FichaNoConformidad);
